$illJq(function(){

  // 【共通】グローバルナビをマウスオーバーするとオーバーレイを表示
  globalNavHoverOverlayShow();

  // 【共通】スクロールすると要素がフェードイン
  animationFadeUp();

  // 【共通】スクロールしてからトップへ戻るを非表示
  pagetopDisplay();

  // 【共通】Haglöfs、DBブランド別表示切替
  brandSwitchCtrl();

  // 【お問い合わせページ】商品について問い合わせる
  contactCommentCustom();

});

$illJq(window).on('load', function() {

  //【共通】お知らせバーの有無によるドロップダウンメニュー位置の調整
  headerPositionCtrl();

  // タブ切り替え　タブアニメーション
  tabChangeAnimation();

  // カートポップアップの位置調整
  setTimeout(function() {
    contactCartPopupCustom();
  }, 1000);

  // リサイズ実行
  setTimeout(function(){
    $illJq(window).trigger('resize');
  },2000);

});

$illJq(window).resize(function() {
  // 最近チェックした商品の画像配置、サイズ調整
  recentlyViewedProductsReSize();
});

/* 【共通】お知らせバーの有無によるドロップダウンメニュー位置の調整
=====================================================================*/
function headerPositionCtrl() {
  if($illJq(window).width() > 749){
    var bottomAnnouncebarHeight = $illJq('.m-head-bnr').height(); //下部のアナウンスバーの高さを取得

    if(bottomAnnouncebarHeight) {
      $illJq('.header-global-sub-nav.widemenu').addClass('bottom_announcebar');
    } else {
      $illJq('.header-global-sub-nav.widemenu').removeClass('bottom_announcebar');
    }
  }
}

/* 【共通】グローバルナビをマウスオーバーするとオーバーレイを表示
=====================================================================*/
function globalNavHoverOverlayShow() {
  $illJq('.header-global-nav-list').mouseover(function() {
    $illJq('body').addClass('gnav-overlay');
  }).mouseout(function() {
    $illJq('body').removeClass('gnav-overlay');
  });
}

/* 【共通】スクロールすると要素がフェードイン
=====================================================================*/
function animationFadeUp() {
  $illJq(window).on('load scroll',function (){
    $illJq('.animation-fade-up').each(function(){
      //ターゲットの位置を取得
      var target = $illJq(this).offset().top;
      //スクロール量を取得
      var scroll = $illJq(window).scrollTop();
      //ウィンドウの高さを取得
      var height = $illJq(window).height();
      //ターゲットまでスクロールするとフェードインする
      if (scroll > target - height){
        //クラスを付与
        $illJq(this).addClass('active-fade-up');
      }
    });
  });
}

/* 【共通】スクロールしてからトップへ戻るを非表示
=====================================================================*/
function pagetopDisplay() {
  $illJq(window).scroll(function() {
    var nowScrollForPagetop = $illJq(this).scrollTop();
    var windowsHeight = $illJq(window).height();
    if(nowScrollForPagetop >= windowsHeight){
      $illJq('.back-to-top').addClass('pagetop-view');
    }else{
      $illJq('.back-to-top').removeClass('pagetop-view');
    }
  });
}

/* 【共通】Haglöfs、DBブランド別表示切替
=====================================================================*/
//Haglöfs、DBブランドのヘッダー表示切替
function brandSwitchCtrl(){
  var brandHaglofsFlag = false; //Haglöfsフラグ　初期はfalse
  var brandDbFlag = false; //Dbフラグ　初期はfalse
  var vendorName; //販売元のテキストを取得

  //商品ページの場合
  if($illJq('.js-vendor-name').length){
    vendorName = $illJq('.js-vendor-name').text(); 
    //販売元が「Haglöfs」の場合
    if(vendorName.indexOf('Haglöfs')  > -1) {
      //Haglöfsフラグをtrueにする
      brandHaglofsFlag = true;
      //販売元が「DB」の場合
    } else if(vendorName.indexOf('Db')  > -1) {
      //Dbフラグをtrueにする
      brandDbFlag = true;
    }
  }

  //Haglöfsトップページ、Haglöfsカテゴリページ、「hagcategory」を含むカテゴリページの場合、「haglofs」を含むブログページの場合
  if(Util.isPage('pages/haglofs') || Util.isPage('collections/haglofs') || Util.isPage('collections/hagcategory') || Util.isPage('blogs/blog/haglofs') || Util.isPage('pages/store_haglofs')) {
    //Haglöfsフラグをtrueにする
    brandHaglofsFlag = true;
  //DBトップページ、Dbカテゴリページ、「dbcategory」を含むカテゴリページの場合、「dbcategory」を含むブログページの場合
  } else if(Util.isPage('pages/db') || Util.isPage('collections/db') || Util.isPage('collections/dbcategory') || Util.isPage('blogs/blog/dbcategory') || Util.isPage('pages/store_db')) {
    //Dbフラグをtrueにする
    brandDbFlag = true;
  }

  //検索結果ページの場合
  if(Util.isPage('search')) {
    //Haglofsのみ抽出されている場合はHaglofs用の表示
    //Dbのみ抽出されている場合はDb用の表示
    //読み込んで1秒後に実行
    setTimeout(function(){
      sortBrandSwitchCtrl();
    },1000);

    //ブランドの抽出条件に変更があった場合
    $illJq('[name="filter.p.vendor"]').on("change",function(){
      //変更して1秒後に実行
      setTimeout(function(){
        //Haglofsのみ抽出されている場合はHaglofs用の表示
        //Dbのみ抽出されている場合はDb用の表示
        sortBrandSwitchCtrl();
      },1000);
    });
  }



  //Haglöfsフラグがtrueの場合、検索結果をHaglöfsで抽出する
  //Dbフラグがtrueの場合、検索結果をDbで抽出する
  $illJq('.search-form, #search-form').on('submit', function(e){
    e.preventDefault();
    var term = $illJq(this).find('input[name="q"]').val();
    var linkURL;
    //Haglöfsフラグがtrueの場合
    if(brandHaglofsFlag) {
      //検索結果に「&filter.p.vendor=Haglöfs"」を追加する
      linkURL = $illJq(this).attr('action') + '?type=product&q=' + term + "&filter.p.vendor=Haglöfs";
    //Dbフラグがtrueの場合
    } else if(brandDbFlag) {
      //検索結果に「&filter.p.vendor=Db"」を追加する
      linkURL = $illJq(this).attr('action') + '?type=product&q=' + term + "&filter.p.vendor=Db";
    //Haglöfsフラグ、Dbフラグがfalseの場合
    } else {
      //vendorで抽出しない
      linkURL = $illJq(this).attr('action') + '?type=product&q=' + term;
    }
    //設定したURLに遷移する
    window.location = linkURL;
  });

  //Haglöfsフラグがtrueの場合
  if(brandHaglofsFlag){
    //Haglöfs用の表示にする
    brandHaglofsDisplay(); 
  } else if(brandDbFlag) {
    //Db用の表示にする
    brandDbDisplay(); 
  } else {
    //標準の表示にする
    brandCommonDisplay(); 
  }
  
}

//Haglofsのみ抽出されている場合はHaglofs用の表示
//Dbのみ抽出されている場合はDb用の表示
function sortBrandSwitchCtrl(){
  var searchVendor = "filter.p.vendor"; //vendor抽出時のパラメータ名
  var searchParamsArray = location.search.substring(1).split('&'); //URLの?の後ろを&で区切ったものを配列にして代入
  var searchVendorCount = 0; //vendorをカウントする変数
  var searchVendorValue; //vendorパラメータの値を取得する変数
  var sortParams = (new URL(document.location)).searchParams; // パラメータを取得
  var sortVendor = sortParams.get(searchVendor); // パラメータからvendorを取得

  // searchParamsArrayがある限りループさせる
  for(var i=0; searchParamsArray[i]; i++) {

    // 変数searchVendorValueにsearchParamsArrayを=で区切り配列に分割する
    searchVendorValue = searchParamsArray[i].split('=');

    // 抽出しているvendorを含む場合
    if(searchVendorValue.indexOf(searchVendor)  > -1) {
      searchVendorCount = searchVendorCount + 1; //vendorをカウントする変数に1を足す
    }
  }
  
  //絞り込みブランドが1つ以下の場合
  if(searchVendorCount <= 1) {
    //抽出されているブランドがHaglöfsのみの場合
    if(sortVendor == 'Haglöfs'){
      //Haglöfs用の表示にする
      brandHaglofsDisplay(); 
    //抽出されているブランドがDbのみの場合
    } else if(sortVendor == 'Db') {
      //Db用の表示にする
      brandDbDisplay();
    //抽出されているブランドがHaglöfsとDb以外の場合
    } else {
      //標準の表示にする
      brandCommonDisplay();
    }
  //絞り込みブランドが2つ以上の場合
  } else {
    //標準の表示にする
    brandCommonDisplay();
  }
}

//Haglöfs用の表示
function brandHaglofsDisplay(){
  $illJq('.collection_haglofs_view').css('display','inherit');//.collection_haglofs_viewを表示
  $illJq('.collection_normal_view').css('display','none');//.collection_normal_viewを非表示
  $illJq('.collection_db_view').css('display','none');//.collection_db_viewを非表示
}

//Db用の表示
function brandDbDisplay(){
  $illJq('.collection_db_view').css('display','inherit');//.collection_db_viewを表示
  $illJq('.collection_normal_view').css('display','none');//.collection_normal_viewを非表示
  $illJq('.collection_haglofs_view').css('display','none');//.collection_haglofs_viewを非表示
}

//標準の表示
function brandCommonDisplay(){
  $illJq('.collection_normal_view').css('display','inherit');//.collection_db_viewを表示
  $illJq('.collection_db_view').css('display','none');//.collection_normal_viewを非表示
  $illJq('.collection_haglofs_view').css('display','none');//.collection_haglofs_viewを非表示
}

/* 商品について問い合わせる
=====================================================================*/
function contactCommentCustom(){

  var formCommentArea = '.contact-comment-textarea'; //商品情報を入力するテキストエリア

  //Formページ
  if( $illJq( formCommentArea ).length ){
    var urlParam = location.search;
    if(urlParam.match(/product_title/) && urlParam.match(/product_url/)){
      var productParams = Util.getQueryParams();
        var productTitle = Util.decodeUri( productParams['product_title'] );
        var productURL = Util.decodeUri( productParams['product_url'] );

      var customComment = '商品名：' + productTitle + '\nURL：' + productURL;

      $illJq(formCommentArea).val(customComment);
    } else {
      return false;
    }
  } else{
    return false;
  }

}


/* 最近チェックした商品の画像サイズを調整
=====================================================================*/
function recentlyViewedProductsReSize() {
  if($illJq('#recently-viewed-products').length && $illJq(window).width() >= 750){
    var recentlyViewedProductsWhidth = $illJq('#recently-viewed-products').outerWidth();
    var recentlyViewedProductsImageWidth = (recentlyViewedProductsWhidth - 45 * 5) / 6;
    $illJq('#recently-viewed-products .product').css('width',recentlyViewedProductsImageWidth + 'px' )
    $illJq('#recently-viewed-products .product .image').css('width',recentlyViewedProductsImageWidth + 'px' )
    $illJq('#recently-viewed-products .product .image a img').css('width',recentlyViewedProductsImageWidth + 'px' )
  }
  else
  {
    $illJq('#recently-viewed-products .product').css('width','calc(100% / 3.5)' )
    $illJq('#recently-viewed-products .product .image').css('width','100%' )
    $illJq('#recently-viewed-products .product .image a img').css('width','100%' )
  }
}

/* タブ切り替え　タブアニメーション
=====================================================================*/
function tabChangeAnimation() {

  if($illJq('.js-tab-btn-wrap').length){
    var lampSign = document.getElementsByClassName('lampSign');
    var jsTabBtnWrapSign = document.getElementsByClassName('js-tab-btn-wrap');
    for (let i = 1; i < lampSign.length + 1; i++) {
      lampSign[i - 1].setAttribute("id", "lamp" + i);
      jsTabBtnWrapSign[i - 1].classList.add('js-tab-btn-wrap' + i);
      $illJq('#lamp' + i).css('width', $illJq('.js-tab-btn-wrap' + i + ' .active').outerWidth() + 'px');
      $illJq('#lamp' + i).css('left', $illJq('.js-tab-btn-wrap' + i + ' .active').position().left + 'px');
      
      $illJq('.js-tab-btn-wrap' + i + ' .tabswitching_title').click(function () {
        setTimeout(function() {
          var thisclass = $illJq(this).attr('class');
          $illJq('').removeClass().addClass('#lamp' + i).addClass(thisclass);
          $illJq('#lamp' + i).css('width', $illJq('.js-tab-btn-wrap' + i + ' .active').outerWidth() + 'px');
          let off = $illJq('.js-tab-btn-wrap' + i + ' .active').position();
          $illJq('#lamp' + i).css('left', off.left + 'px');
        }, 100);
      });
      
      $illJq(window).resize(function() {
        $illJq('#lamp' + i).css('width', $illJq('.js-tab-btn-wrap' + i + ' .active').outerWidth() + 'px');
        $illJq('#lamp' + i).css('left', $illJq('.js-tab-btn-wrap' + i + ' .active').position().left + 'px');
      });
    }
  }

}

/* カートポップアップの位置調整
=====================================================================*/
$illJq('.btn_add_to_cart').click(function() {
  setTimeout(function() {
    contactCartPopupCustom();
  }, 1000);
});

$illJq(window).scroll(function() {
  setTimeout(function() {
    contactCartPopupCustom();
  }, 1000);
});

function contactCartPopupCustom(){
 if($illJq(window).width() < 750) {
    var scrollMainProduct = $illJq(window).scrollTop();
    $illJq('#cart-notification').css('top',  scrollMainProduct + 25 +'px');
  }
  else {
    var scrollMainProduct = $illJq(window).scrollTop();
    if(scrollMainProduct<10){
	  var headerBottomPosition = $illJq('#header_id_for_catpopup').offset().top + $illJq('#header_id_for_catpopup').outerHeight(true);
      $illJq('#cart-notification').css({'cssText': 'top: '+headerBottomPosition+'px !important;'}); 
    }
    else
    {
      $illJq('#cart-notification').css('top', '22.2%');
    }
  }
}

/* スライダー
=====================================================================*/
// スリックスライダー（１スライド3画像）
$illJq('.slider-collection').slick({
  autoplay: false,//自動的に動き出すか。初期値はfalse。
  infinite: false,//スライドをループさせるかどうか。初期値はtrue。
  autoplaySpeed:5000,
  speed:800,
  slidesToShow: 3,//スライドを画面に4枚見せる
  slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
  dots: false,//下部ドットナビゲーションの表示
  cssEase: 'linear',//開始から終了まで一定に変化する
  swipeToSlide:true,//スワイプして設定している画面数以上に動かすか
});

// スリックスライダー（１スライド1.6画像）
$illJq('.slider-collection-one-half').slick({
  autoplay: false,//自動的に動き出すか。初期値はfalse。
  infinite: false,//スライドをループさせるかどうか。初期値はtrue。
  autoplaySpeed:5000,
  speed:800,
  slidesToShow: 1.6,//スライドを画面に4枚見せる
  slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
  dots: false,//下部ドットナビゲーションの表示
  cssEase: 'linear',//開始から終了まで一定に変化する
  swipeToSlide:true,//スワイプして設定している画面数以上に動かすか
});

// スリックスライダー（１スライド1.2画像）
$illJq('.slider-collection-one-half-mobile').slick({
  autoplay: false,//自動的に動き出すか。初期値はfalse。
  infinite: false,//スライドをループさせるかどうか。初期値はtrue。
  autoplaySpeed:5000,
  speed:800,
  slidesToShow: 1.2,//スライドを画面に4枚見せる
  slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
  dots: false,//下部ドットナビゲーションの表示
  cssEase: 'linear',//開始から終了まで一定に変化する
  swipeToSlide:true,//スワイプして設定している画面数以上に動かすか
});

// スリックスライダー（１スライド2画像）
$illJq('.slider-collection-two').slick({
  autoplay: false,//自動的に動き出すか。初期値はfalse。
  infinite: true,//スライドをループさせるかどうか。初期値はtrue。
  autoplaySpeed:5000,
  speed:800,
  slidesToShow: 1,//スライドを画面に4枚見せる
  slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
  dots: false,//下部ドットナビゲーションの表示
  centerMode: true,
  centerPadding: "20%",
  /*initialSlide: 1,*/
  cssEase: 'linear',//開始から終了まで一定に変化する
  swipeToSlide:true,//スワイプして設定している画面数以上に動かすか
});

// 商品詳細のブログ記事(PC)
$illJq('.slider-blog_productpage-pc').slick({
  autoplay: false,//自動的に動き出すか。初期値はfalse。
  infinite: false,//スライドをループさせるかどうか。初期値はtrue。
  autoplaySpeed:5000,
  speed:800,
  slidesToShow: 3,//スライドを画面に4枚見せる
  slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
  dots: false,//下部ドットナビゲーションの表示
  cssEase: 'linear',//開始から終了まで一定に変化する
  swipeToSlide:true,//スワイプして設定している画面数以上に動かすか
});

var sliderRanking = $illJq('.slider-collection-tab-pc').slick({
  autoplay: false,//自動的に動き出すか。初期値はfalse。
  infinite: false,//スライドをループさせるかどうか。初期値はtrue。
  slidesToShow: 5,//スライドを画面に4枚見せる
  slidesToScroll: 1,//1回のスクロールで4枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
  dots: false,//下部ドットナビゲーションの表示
  cssEase: 'linear',//開始から終了まで一定に変化する
  swipeToSlide:true,//スワイプして設定している画面数以上に動かすか
  speed:800,
});

// スリックスライダー（１スライド2.5画像）
var sliderCollectionTabMobile = $illJq('.slider-collection-tab-mobile').slick({
  autoplay: false,//自動的に動き出すか。初期値はfalse。
  infinite: false,//スライドをループさせるかどうか。初期値はtrue。
  autoplaySpeed:5000,
  speed:800,
  slidesToShow: 2.5,//スライドを画面に4枚見せる
  slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
  dots: false,//下部ドットナビゲーションの表示
  cssEase: 'linear',//開始から終了まで一定に変化する
  swipeToSlide:true,//スワイプして設定している画面数以上に動かすか
});

$illJq('.slider-product').slick({
  autoplay: false,//自動的に動き出すか。初期値はfalse。
  infinite: false,//スライドをループさせるかどうか。初期値はtrue。
  slidesToShow: 5,//スライドを画面に4枚見せる
  slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
  arrows: false,
  speed:800,
  dots: false,//下部ドットナビゲーションの表示
  cssEase: 'linear',//開始から終了まで一定に変化する
  swipeToSlide:true,//スワイプして設定している画面数以上に動かすか
});

